// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataMovie_wrapper__f5kas","searchAction":"DataMovie_searchAction__2AAQ1"};